import { Box } from "@mui/material";
import { memo } from "react";

/**
 * ✅ Helper inside component (keeps API clean)
 */
function getRoleLabel(roles = []) {
  if (!roles || roles.length === 0) return null;

  if (roles.includes(2) && roles.includes(3)) return "Alle";
  if (roles.includes(2)) return "LP";
  if (roles.includes(3)) return "SuS";

  return null;
}

/**
 * ✅ SondertagLockInfo
 * Displays role restriction or lock icon
 */
function SondertagLockInfo({ roles = [] }) {
  const roleLabel = getRoleLabel(roles);

  // ✅ nothing to show
  if (!roleLabel && roles.length > 0) return null;

  return (
    <>
      {/* ✅ Role-based restriction */}
      {roleLabel && (
        <Box
          component="span"
          sx={{
            fontSize: "0.7rem",
            opacity: 0.7,
          }}
        >
          ({roleLabel})
        </Box>
      )}

      {/* ✅ Fully locked (no roles) */}
      {roles.length === 0 && (
        <Box
          component="span"
          sx={{
            fontSize: "0.8rem",
            opacity: 0.6,
          }}
        >
          🔒
        </Box>
      )}
    </>
  );
}

export default memo(SondertagLockInfo);
